export enum NetworkStatusActionType {
  NETWORK_UP_EVENT = 'pubnub/NETWORK_UP_EVENT',
  NETWORK_DOWN_EVENT = 'pubnub/NETWORK_DOWN_EVENT',
}
